
var keyMirror = require('keymirror');

module.exports = keyMirror({
    UNAUTHORIZED_EXCEPTION: null,
    LOCATION_RATES: null,
    REGION_RATES: null,
    CITY_RATES: null
});